import { render, staticRenderFns } from "./AdminFooterComponent.vue?vue&type=template&id=6c73e338"
import script from "./AdminFooterComponent.vue?vue&type=script&lang=js"
export * from "./AdminFooterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports